export const FILTERS_LIST: { name: "category" | "question" | "answer"; label: string }[] = [
	{
		name: "category",
		label: "title_category",
	},
	{
		name: "question",
		label: "title_question",
	},
	{
		name: "answer",
		label: "title_answer",
	},
];
